import { allClustersSelector } from 'app/plugins/infrastructure/components/combinedClusters/selectors'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'
import { findCluster } from 'k8s/util/helpers'
import { durationBetweenDates } from 'utils/misc'
import { IPodDisruptionBudgetSelector } from './model'

export const podDisruptionBudgetsSelector = createSharedSelector(
  getDataSelector<DataKeys.PodDisruptionBudgets>(
    DataKeys.PodDisruptionBudgets,
    ['clusterId'],
    ['clusterId', 'namespace'],
  ),
  allClustersSelector,
  (rawPodDisruptionBudgets, allClusters): IPodDisruptionBudgetSelector[] => {
    return rawPodDisruptionBudgets.map((rawPodDisruptionBudget) => {
      const { clusterId, metadata } = rawPodDisruptionBudget
      const { name: clusterName, clusterType: clusterType } = findCluster(allClusters, clusterId)
      return {
        ...rawPodDisruptionBudget,
        clusterName,
        clusterId,
        clusterType,
        age: durationBetweenDates({ labels: ['d'] })(metadata?.creationTimestamp),
        ownerReferences: metadata?.ownerReferences,
        creationTimestamp: metadata?.creationTimestamp,
        labels: metadata?.labels,
        annotations: metadata?.annotations,
      }
    })
  },
)
